exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mensaje {\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  margin: 0px 15px; \r\n  background: #FFFBCC;\r\n  padding: 10px;\r\n  border: 1px solid #ccc;\r\n  z-index: 1000;\r\n  -webkit-box-shadow: 0 2px 8px rgba(0,0,0,0.2);\r\n          box-shadow: 0 2px 8px rgba(0,0,0,0.2);\r\n  border-radius: 4px;\r\n}\r\n\r\n.mensaje-header {\r\n  font-weight: bold;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.mensaje-body {\r\n  font-size: 14px;\r\n}\r\n\r\n@media only screen and (max-width: 48em) { .mensaje { top: 70px; } }\r\n\r\n@media only screen and (min-width: 48em) { .mensaje { top: 69px; } }\r\n\r\n@media only screen and (min-width: 64em) { .mensaje { top: 11px; } }\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/home/Components/mensaje-dm.component.css
// module id = ../../../../../src/app/home/Components/mensaje-dm.component.css
// module chunks = main